import { render } from "./DescriptionsTemplate.vue?vue&type=template&id=23c4eea9&scoped=true"
import script from "./DescriptionsTemplate.vue?vue&type=script&lang=js"
export * from "./DescriptionsTemplate.vue?vue&type=script&lang=js"

import "./DescriptionsTemplate.vue?vue&type=style&index=0&id=23c4eea9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23c4eea9"

export default script